import { Base } from "./base.model";

export abstract class Persistent extends Base{

}